import React from 'react';

class SearchForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            text_search : ''
        }
    }

    handleChange =(e) =>{
        this.setState({
            text_search : e.target.value
        });
    }
    handleSubmit = (e) =>{
        e.preventDefault();
        this.props.submitForm(this.state.text_search);
    }

    render(){
        return(
            <form method="POST" onSubmit={this.handleSubmit}>
                <div className="d-flex flex-wrap justify-content-center mb-3">
                    <div className="col-xs-12 col-md-6 input-group mb-3">
                        <input type="text" className="form-control" onChange={this.handleChange} value={this.state.text_search} placeholder={this.props.placeHolder} aria-describedby="button-addon2"/>
                        <div className="input-group-append">
                            <button type="submit" className="btn btn-outline-dark">Buscar</button>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default SearchForm;